export default __webpack_public_path__ + "static/media/green_bolt.e473082e.svg";